import { render, staticRenderFns } from "./dataStatisticsMamMaster.vue?vue&type=template&id=38439a07&scoped=true"
import script from "./dataStatisticsMamMaster.vue?vue&type=script&lang=js"
export * from "./dataStatisticsMamMaster.vue?vue&type=script&lang=js"
import style0 from "./dataStatisticsMamMaster.vue?vue&type=style&index=0&id=38439a07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38439a07",
  null
  
)

export default component.exports